import { Box } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { useAtom } from 'jotai';
import { InView } from 'react-intersection-observer';
import ClientScheduler from 'ui-component/mounting/ClientScheduler';
import Scheduler from 'ui-component/mounting/Scheduler';
import { orderIdAtom } from 'views/pages/order/OrderManagePage';

const OrderMountingScheduler = () => {
    const { user } = useAuth();
    const [orderId] = useAtom(orderIdAtom);
    return (
        <Box sx={{ p: 0 }}>
            <InView triggerOnce>
                {({ inView, ref }) => (
                    <Box ref={ref}>
                        {inView && (
                            <>
                                {user?.role! === 'client' ? (
                                    <ClientScheduler orderId={orderId!} />
                                ) : (
                                    <Scheduler orderId={orderId!} loadButton />
                                )}
                            </>
                        )}
                    </Box>
                )}
            </InView>
        </Box>
    );
};

export default OrderMountingScheduler;
